export default "__VITE_ASSET__BiRMhaOL__"